import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';


import {Button, Dropdown, DropdownToggle, DropdownMenu} from 'reactstrap';

import { MagstimColor, isPDA } from "common";

// import * as util from 'util'

class MagstimDropdown extends React.Component {

    constructor() {
        super();

        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.onSelect = this.onSelect.bind(this);

        this.state = {
            dropDownValue: undefined,
            dropDownKey:undefined,
            dropDownValueFromProps: undefined,
            dropDownKeyFromProps: undefined,
            dropdownOpen: false,
            dropDownMinWidth: isPDA() ? 'px': '200px',
            iconFontSize: isPDA() ? '22px': '30px'

        };

        this.dropdown = React.createRef();
        this.toggle = React.createRef();
        this.menu = React.createRef();
    }

    onSelect = (event) => {
        this.set(event.currentTarget.textContent);
        if ((undefined !== this.props.onSelect) && (null !== this.props.onSelect)) {
            this.props.onSelect(event.currentTarget.id)
        }
    }

    set = (value) => {

        var currentKey = undefined;

        for (var child of this.props.children){
            if (value === child.props.children) {
                currentKey = child.key;
            }     
        }

        this.setState({ dropDownValue: value, dropDownKey: currentKey});
    }

    setKey = (key) => {
        console.log('setKey', key, this.props.children);
        for (var child of this.props.children){
            if (key === child.key) {
                this.setState({ dropDownValue: child.props.children, dropDownKey: key});
                break;
            }     
        }
    }

    getKey = () => {
        return this.state.dropDownKey;
    }

    getValue = () => {
        return this.state.dropDownValue;
    }

    toggleDropdown = () => {

        //console.log(`toggleDropdown dropdown=${JSON.stringify(this.dropdown.current)} toggle=${JSON.stringify(this.toggle.current)} menu=${JSON.stringify(this.menu.current)}`, this.dropdown.current, this.toggle.current, this.menu.current);

        if(this.state.dropdownOpen){
            this.setState({dropdownOpen: false});
        }else{
            this.setState({dropdownOpen: true});
        }
        
    };


    static getDerivedStateFromProps(props, state) {

        if ((undefined !== props.children) && (null !== props.children) && (props.children.length > 0)) {

            var activeItem = props.children[0];

            for (var child of props.children) {

                if (undefined !== child.props) {

                    if ((undefined !== child.props.active) && child.props.active) {
                        activeItem = child;
                        break;
                    }
                    else if ((undefined !== props.dropDownKey) && (props.dropDownKey === child.props.id)) {
                        activeItem = child;
                        break;
                    }
                    else if ((undefined !== props.dropDownValue) && (props.dropDownValue === child.props.children)) {
                        activeItem = child;
                        break;
                    }
                }
            }

            // getDerivedStateFromProps is called before every render - so even when the internal state is updated.
            // So we don't want that state overwritten from the props every time. 
            // So save the last used prop and only update the state when the prop is changed.  
            if (state.dropDownValueFromProps !== activeItem.props.children || state.dropDownKeyFromProps !== activeItem.key) {

                state.dropDownValueFromProps = activeItem.props.children;
                state.dropDownKeyFromProps =  activeItem.key;

                state.dropDownValue = activeItem.props.children;
                state.dropDownKey = activeItem.key;
            }
        }
        
        return state;
    }

    render() {

        var icon = undefined;
        if ((undefined !== this.props.icon) && (null !== this.props.icon)) {
            icon = <i className={this.props.icon}></i>;
        }

        return (
            <Wrapper className="magstim-dropdown-wrapper" dropDownMinWidth={this.state.dropDownMinWidth} iconFontSize={this.state.iconFontSize}>
                {icon}        
                <Dropdown 
                          ref={this.dropdown}
                          className="btn-group"
                          direction='down'
                          toggle={this.toggleDropdown}
                          isOpen={this.state.dropdownOpen}
                          size={this.props.size}
                          disabled={this.props.disabled}>

                    <Button className="ui-droptext" color="secondary" onClick={this.toggleDropdown} disabled={this.props.disabled}>{this.state.dropDownValue}</Button>
                    
                    <DropdownToggle ref={this.toggle} className="ui-dropbtn" split color="secondary" disabled={this.props.disabled} onClick={this.toggleDropdown} />
                    
                    <DropdownMenu ref={this.menu} id={this.props.id}  disabled={this.props.disabled}>
                        {
                            this.props.children.map &&
                                this.props.children.map(e => {
                                    var item = React.cloneElement(e, {onClick: this.onSelect});
                                    return item;                       
                    })}
                    
                    </DropdownMenu>

                </Dropdown>
            </Wrapper>
        );
    }

    componentDidMount() {
    }
}

MagstimDropdown.propTypes = {
    onSelect: PropTypes.func,
    id: PropTypes.string,
    size: PropTypes.string,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    children: PropTypes.array,
    dropDownKey: PropTypes.string,
    dropDownValue: PropTypes.string,
};

MagstimDropdown.defaultProps = {
    onSelect: undefined,
    id: "default-dropdown",
    size: "md",
    children: [],
    dropDownKey: undefined,
    dropDownValue: undefined,
};

const Wrapper = styled.div`
    display: flex;
    flex: 1;
    margin-top: 5px;
    margin-bottom: 5px;

    i {
        margin: auto 15px;
        font-size: ${props => props.iconFontSize};
        line-height: 40px;
        vertical-align: middle;
    }

    .btn-group {
        position: relative;
        width: 100%;
        min-width:  ${props => props.dropDownMinWidth};
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
        border-radius: .9rem;

        .ui-droptext {
            min-width: 80px;
            white-space: normal;
            word-break: break-all;
            overflow: hidden;
            background-color: ${ MagstimColor.MagstimTextBackground };
            text-align: left;
            border: 0;
            outline: 0;
        }
        .ui-dropbtn {
            max-width: 50px;
            border: 0px;
            background-color: ${ MagstimColor.MagstimGrey109 };
            color: ${ MagstimColor.MagstimButtonText };    
            outline: 0;
        }

        .dropdown-item{
            border-bottom: 0px;
        }

        .dropdown-menu {
            position: absolute;
            min-width: 10px;
            margin-top: 0;
            margin-left: 0px;
            margin-right: 5px;
            width: 100%;
            left: 0px;
            padding-left: 0px;
            transform: translate3d(0px, 34px, 0px)!important;
            background-color: ${ MagstimColor.MagstimTextBackground };
            border: none;
            border-top-left-radius: 0;
            border-top-right-radius: 0;

            max-height: 450px;
            overflow-y: auto;
            overflow-x: hidden;

            button.dropdown-item.active,
            button.dropdown-item {
                color: ${ MagstimColor.MagstimWhite };
                background: ${ MagstimColor.MagstimTextBackground };
                line-height: 25px;
                white-space: normal;
                word-break: break-all;
                overflow: hidden;
                &:hover {
                    color: ${ MagstimColor.MagstimWhite };
                    background: ${ MagstimColor.MagstimPrimaryButton };
                }
            }
            &::-webkit-scrollbar {
                width:20px; /*  manage scrollbar width here */
            }
            &::-webkit-scrollbar-track {
                -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
                background-color: ${ MagstimColor.MagstimSecondaryButton};
                border-radius: 0;
                border-bottom-right-radius: .25rem;
            }
            &::-webkit-scrollbar-thumb {
                background-color: ${ MagstimColor.MagstimPrimaryBlue};
                border-radius: 0;
                border-bottom-right-radius: .25rem;
            
            }
        }
    }

    .btn-group-lg {
        position: relative;
        width: 100%;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
        border-radius: .9rem;

        .ui-droptext {
            min-width: 120px;
            background-color: ${ MagstimColor.MagstimTextBackground };
            text-align: left;
            border: 0;
            outline: 0;
        }
        .ui-dropbtn {
            max-width: 50px;
            border: 0px;
            background-color: ${ MagstimColor.MagstimGrey109 };
            color: ${ MagstimColor.MagstimButtonText };
            outline: 0;
        }

        .dropdown-menu {
            position: absolute;
            margin-top: 0;
            margin-left: 0px;
            margin-right: 5px;
            width: 100%;
            left: 0px;
            padding-left: 0px;
            transform: translate3d(0px, 50px, 0px)!important;
            background-color: ${ MagstimColor.MagstimTextBackground };
            border: none;
            border-top-left-radius: 0;
            border-top-right-radius: 0;

            max-height: 450px;
            overflow-y: auto;
            overflow-x: hidden;

            button.dropdown-item.active,
            button.dropdown-item {
                color: ${ MagstimColor.MagstimWhite };
                background: ${ MagstimColor.MagstimTextBackground };
                line-height: 50px;
                &:hover {
                    color: ${ MagstimColor.MagstimWhite };
                    background: ${ MagstimColor.MagstimPrimaryButton };
                }
            }
            &::-webkit-scrollbar {
                width:20px; /*  manage scrollbar width here */
            }
            &::-webkit-scrollbar-track {
                -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
                background-color: ${ MagstimColor.MagstimSecondaryButton};
                border-radius: 0;
                border-bottom-right-radius: .25rem;
            }
            &::-webkit-scrollbar-thumb {
                background-color: ${ MagstimColor.MagstimPrimaryBlue};
                border-radius: 0;
                border-bottom-right-radius: .25rem;
            
            }
        }
    }
`;

export default MagstimDropdown;